const Config = require("./Config");

module.exports = {
	Config,
};
